import React, { useContext } from 'react';
import { Empty } from 'antd';

import SectionContext from '@totem/components/devices/variables/presentation/layout/layoutSection/SectionContext';
import CurrentValuesWithStatusTable from '@totem/components/devices/variables/presentation/layout/templates/components/CurrentValuesWithStatusTable';
import { isNotNull } from '@totem/utilities/common';

const CurrentValueWithStatusTablesSection = () => {
  const { sectionLayout } = useContext(SectionContext);

  const sectionVariables = isNotNull(sectionLayout)
    ? sectionLayout.variables.filter(
        (element) => element.type === 'variablePurpose',
      )
    : [];

  return (
    <>
      {sectionVariables.length > 0 &&
        sectionVariables.map((sectionVariable) => (
          <CurrentValuesWithStatusTable
            key={sectionVariable.id}
            purpose={sectionVariable.id}
            maxDecimalPlaces={sectionVariable.max_decimal_places}
          />
        ))}
      {sectionVariables.length === 0 && <Empty />}
    </>
  );
};

export default CurrentValueWithStatusTablesSection;
